<app-entity-page
    [closeClicked]="closeClicked"
    [detailsContentTitle]="getDetailsTitle()"
    [mapContentTitle]="'iaa.conservationArchive.mapTitle' | translate"
    [loading]="folderDetailsLoading">
    <ng-template #detailsContent>
        <div class="conservation-folder-content">
            <conservation-archive-folder-details
                [details]="folderDetails"
                [currentLanguage]="currentLanguage$"
                [onViewSite]="onViewSite.bind(this)"
                [onViewFolder]="onViewFolder.bind(this)"
                [onViewDocument]="onViewDocument.bind(this)"
                [onDownload]="onDownload.bind(this)">
            </conservation-archive-folder-details>
        </div>
    </ng-template>

    <ng-template #mapContent>
        <div class="conservation-folder-map">
            <app-arcgis-map [shapes]="shapes" [mapControls]="mapControls" [extentAll]="true"></app-arcgis-map>
        </div>
    </ng-template>

    <ng-template #footer>
        <div class="actions-footer">
            <p-button
              styleClass="icon-button"
              [ngClass]="{'icon-button':true,'en': (currentLanguage$ | async)=== 'en'}"
              [link]="true"
              icon="pi pi-download"
              [label]="'iaa.conservationArchive.folder.download' | translate"
              [tabindex]="0"
              [disabled]="!folderDetails.folderHasScannedFiles"
              [ariaLabel]="'iaa.aria.download' | translate"
              (click)="onDownload()"></p-button>
        </div>
    </ng-template>
</app-entity-page>
